import React, { useEffect, useState } from 'react'
import './App.css'
import './EditEvent.css'
import './EditEventSales.css'
import './EditEventComp.css'
import { Link, Redirect, useHistory, useLocation } from 'react-router-dom'
import Axios from 'axios'
import { createPortal } from 'react-dom'
import ClipLoader from 'react-spinners/ClipLoader'
import TopBarProgress from 'react-topbar-progress-indicator'
import { BiMenu } from 'react-icons/bi'
import {
  IoAdd,
  IoAnalyticsOutline,
  IoCalendarOutline,
  IoCheckmark,
  IoChevronBack,
  IoChevronForward,
  IoCloseCircleOutline,
  IoCloudDownloadOutline,
  IoImageOutline,
  IoLocationOutline,
  IoPauseOutline,
  IoPencilOutline,
  IoPeopleOutline,
  IoPlayOutline,
  IoReceiptOutline,
  IoStar,
  IoTicketOutline,
  IoTimeOutline,
  IoTrashOutline,
  IoWalletOutline,
  IoRocketOutline,
  IoSearchOutline,
  IoCashOutline,
  IoTrendingUpOutline,
  IoReturnDownBackOutline,
  IoHourglassOutline,
  IoRemoveCircleOutline,
  IoCopyOutline,
  IoKeyOutline,
  IoLinkOutline,
  IoOpenOutline,
  IoRefreshOutline,
} from 'react-icons/io5'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import { API_URL } from './config'

// Public site that hosts the buy page. Link format: {PURCHASE_BASE}/event/{event_id}/tickets
// Change this if the customer site lives on a different host than the organiser dashboard.
const PURCHASE_BASE = window.location.origin

const REASONS = [
  { value: 'covid-19 restrictions', label: 'Covid-19 restrictions' },
  { value: 'venue cancelled', label: 'Venue cancelled' },
  { value: 'sponsor pulls out', label: 'Sponsor pulls out' },
  { value: 'unfavorable weather conditions', label: 'Unfavorable weather conditions' },
  { value: 'missing paperwork', label: 'Missing paperwork' },
  { value: 'competing events', label: 'Competing events' },
  { value: 'other', label: 'Other' },
]

const STATUS_LABELS = {
  scheduled: 'Scheduled',
  ended: 'Ended',
  postponed: 'Postponed',
  cancelled: 'Cancelled',
  deleted: 'Deleted',
}

const TIER_NAMES = ['VVIP', 'VIP', 'General']

// Sponsor codes skip look-alike characters (0/O, 1/I). 32 symbols, so no modulo bias with bytes.
// const CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'
// const makeSponsorCode = () => {
//   const bytes = new Uint8Array(8)
//   window.crypto.getRandomValues(bytes)
//   const chars = Array.from(bytes, (b) => CODE_ALPHABET[b % CODE_ALPHABET.length])
//   return `KAR-${chars.slice(0, 4).join('')}-${chars.slice(4).join('')}`
// }

const alertStyle = (type) => ({
  margin: '12px 0',
  padding: '10px 12px',
  borderRadius: 8,
  fontSize: 14,
  lineHeight: 1.4,
  background: type === 'error' ? '#fef2f2' : '#ecfdf5',
  color: type === 'error' ? '#b91c1c' : '#047857',
  border: `1px solid ${type === 'error' ? '#fecaca' : '#a7f3d0'}`,
})

// Strips everything except digits, dot and minus so "14,800.00" parses as 14800.
const toNum = (v) => {
  const n = parseFloat(String(v ?? '').replace(/[^0-9.-]/g, ''))
  return Number.isFinite(n) ? n : 0
}

// Maps a transaction's ticket_type to one of the three tiers (VVIP is checked before VIP).
const tierOf = (type) => {
  const s = String(type || '').toLowerCase()
  if (s.includes('vvip')) return 'VVIP'
  if (s.includes('vip')) return 'VIP'
  if (s.includes('gen')) return 'General'
  return null
}

const Dialog = ({ open, onClose, size = 'md', children }) => {
  useEffect(() => {
    if (!open) return undefined
    const onKey = (e) => e.key === 'Escape' && onClose()
    document.addEventListener('keydown', onKey)
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = prev
    }
  }, [open, onClose])

  if (!open) return null
  return createPortal(
    <div className="ee-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className={`ee-sheet ee-sheet-${size}`} role="dialog" aria-modal="true">
        {children}
      </div>
    </div>,
    document.body,
  )
}

function formatToZAR(amount) {
  const n = toNum(amount)
  return `${n < 0 ? '-' : ''}R${Math.abs(n).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`
}

// One coloured stat tile in the Sales card
const Stat = ({ tone, icon, label, value, hint }) => (
  <div className={`ees-stat ees-tone-${tone}`}>
    <span className="ees-ico">{icon}</span>
    <dt>{label}</dt>
    <dd>{value}</dd>
    <dd className="ees-hint">{hint}</dd>
  </div>
)

const Row = ({ icon, title, hint, right, locked, danger }) => (
  <>
    <span className={`ee-row-icon ${danger ? 'is-danger' : ''}`}>{icon}</span>
    <span className="ee-row-text">
      <span className={`ee-row-title ${danger ? 'is-danger' : ''}`}>{title}</span>
      {hint && <span className="ee-row-hint">{hint}</span>}
    </span>
    {right}
    {!right && !locked && <IoChevronForward className="ee-row-chev" />}
  </>
)

const Editevent = (props) => {
  const history = useHistory()
  const baseURL = `${API_URL}/apps/kscanner/webservices.php`
  const location = useLocation()
  const preimageState = location.state?.poster || null

  const [count, setCount] = useState(0)
  const [actionBtn, setActionBtn] = useState('Postpone')
  const [showModal, setShowModal] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [controlModal, setControlModal] = useState(false)
  const [addPoster, setAddPoster] = useState(false)
  const [postponeEvent, setPostponeEvent] = useState(false)
  const [resumeModal, setResumeModal] = useState(false)
  const [getVVIP, setGetVVIP] = useState('')
  const [getVVIPprice, setGetVVIPprice] = useState(0)
  const [getVIPprice, setGetVIPprice] = useState(0)
  const [getGENprice, setGetGENprice] = useState(0)
  const [getVIP, setGetVIP] = useState('')
  const [getGen, setGetGen] = useState('')
  const [currentSelect, setCurrentSelect] = useState('VVIP')
  const [selectedPrice, setSelectedPrice] = useState(0)
  const [selectedTicket, setSelectedTicket] = useState(0)
  const [kidsSelectedPrice, setKidsSelectedPrice] = useState(0)
  const [kidsSelectedTicket, setKidsSelectedTicket] = useState(0)
  const [spinning, setSpinning] = useState('none')
  const [updateDisplay, setUpdateDisplay] = useState('block')
  const [error, setError] = useState('')
  const [successError, setSuccessError] = useState('')
  const [deletion, setDeletion] = useState(null) // { tone, text }
  const [deleted, setDeleted] = useState(0)
  const [image, setImage] = useState(null)
  const [numberOfcustomers, setNumberOfcustomers] = useState(0)
  const [message, setMessage] = useState('')
  const [reason, setReason] = useState('')
  const [subtype, setSubtype] = useState('postpone')
  const [hideUploadBtn, setHideUploadBtn] = useState('none')
  const [checktickets, setChecktickets] = useState('no')
  const [checkcampaign, setCheckcampaign] = useState('no')
  const [checkposter, setCheckposter] = useState('no')
  const [loadBarProgress, setLoadBarProgress] = useState(false)
  const [ticketCount, setTicketCount] = useState(0)
  const [kids_vip_tickets, setKidsVipTickets] = useState(0)
  const [kids_general_tickets, setKidsGeneralTickets] = useState(0)
  const [kids_vip_price, setKidsVipPrice] = useState(0)
  const [kids_general_price, setKidsGeneralPrice] = useState(0)
  const [errorDisplay, setErrorDisplay] = useState('none')
  const [imgname, setImgname] = useState('')
  const [preimage, setPreimage] = useState(preimageState)
  const [delString, setDelString] = useState(null)
  const [kids_price, setKidsPrice] = useState(0)
  const [kids_tickets, setKidsTickets] = useState(0)
  const [checkCampaignStatus, setCheckCampaignStatus] = useState('stop')
  const [cancelTitle, setCancelTitle] = useState('Cancel')
  const [cancelledAt, setCancelledAt] = useState(null)
  const [sales, setSales] = useState({ refunds: 0 })
  const [eventMoney, setEventMoney] = useState(null) // { gross, net } — same source as the dashboard
  const [salesPage, setSalesPage] = useState(0) // 0 = money + tickets, 1 = pending / cancelled / abandoned
  const [txns, setTxns] = useState([])
  const [txLoaded, setTxLoaded] = useState(false)
  const [txModal, setTxModal] = useState(false)
  const [txFilter, setTxFilter] = useState('ALL')
  const [txPage, setTxPage] = useState(1)
  const [txSearch, setTxSearch] = useState('')
  const [txFrom, setTxFrom] = useState('')
  const [txTo, setTxTo] = useState('')
  const txPerPage = 10

  // Complimentary / sponsored tickets. Each generated code owns its own pool of tickets.
  const [compTopUp, setCompTopUp] = useState('') // '' = new code, otherwise an existing code to top up
  const [formMsg, setFormMsg] = useState(null) // { type: 'error' | 'success', text }
  const [isComp, setIsComp] = useState(false)
  const [compMaxPerOrder, setCompMaxPerOrder] = useState(10)
  const [compCode, setCompCode] = useState('') // generated code (string)
  const [compLabel, setCompLabel] = useState('') // sponsor / recipient name (optional)
  const [compLoaded, setCompLoaded] = useState(null) // tier name once this code's tickets are saved
  const [sponsorCodes, setSponsorCodes] = useState([]) // codes already created for this event
  const [copied, setCopied] = useState('') // '', 'code', 'link', or `row-${code}`

  const isMobile = window.innerWidth <= 768
  const [isMob, setIsMob] = useState(isMobile)
  const [collapsed, setCollapsed] = useState(isMobile)

  const updateIsMobile = () => {
    const mobile = window.innerWidth <= 768
    setIsMob(mobile)
    setCollapsed((prev) => (mobile ? true : prev))
  }

  const {
    eventname,
    eventdate,
    eventid,
    poster,
    theme,
    venue,
    expectednum,
    enddate,
    time,
    endtime,
    event_date,
    finish_date,
    campaignstatus,
    is_sponsorship,
    prevpage,
  } = location.state || {}

  useEffect(() => {
    const businessname = localStorage.getItem('businessname')
    const businessid = localStorage.getItem('businessid')
    document.title = `${eventname} - ${businessname}`

    const date = new Date()
    const fulldate = date.toISOString().split('T')[0] // YYYY-MM-DD

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=REPRINTABLETICKETS&eventid=${eventid}`,
      {
        withCredentials: true,
      },
    ).then((res) => {
      if (res.data.val === 0 || res.data.ticketCount === 0) {
        setTicketCount(0)
      } else {
        setTicketCount(res.data.ticketCount)
      }
    })

    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=CHECKCAMPAIGN&eventid=${eventid}`, {
      withCredentials: true,
    }).then((res) => {
      if (res.data.thumbnail === 'yes') {
        setPreimage(
          `${API_URL}/apps/kscanner/posters/${res.data.businessid}/${res.data.eventid}/${res.data.image}`,
        )
      }
      setCheckcampaign(res.data.checkcampaign)
      setCheckposter(res.data.thumbnail)
    })

    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=CHECKTICKETS&eventid=${eventid}`, {
      withCredentials: true,
    }).then((res) => setChecktickets(res.data.tickets))

    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=EVENTSALESDATA&eventid=${eventid}`, {
      withCredentials: true,
    }).then((res) => setNumberOfcustomers(res.data.numberOfcustomers))

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=CHECKIFEVENTDELETED&eventid=${eventid}`,
      {
        withCredentials: true,
      },
    ).then((res) => {
      const deletionStatus = res.data.deletion
      const eventDay = res.data.event_day
      const postponed_at = res.data.postponed_at
      const cancelled_at = res.data.cancelled_at
      const updated_at = res.data.updated_at

      setCancelledAt(cancelled_at)

      let next
      if (cancelled_at != null || postponed_at != null) {
        next = {
          tone: postponed_at != null ? 'postponed' : 'cancelled',
          text: `This event was officially ${
            postponed_at != null ? 'postponed' : 'cancelled'
          } on ${updated_at}. All associated ticket holders have been notified.`,
        }
      } else if (eventDay < fulldate) {
        next = { tone: 'ended', text: `This event concluded on ${eventdate}.` }
      } else if (deletionStatus === 1) {
        next = { tone: 'deleted', text: 'This event has been deleted.' }
      } else {
        next = { tone: 'scheduled', text: `This event is scheduled to take place on ${eventdate}.` }
      }

      setDeleted(deletionStatus)
      setDeletion(next)
    })

    // Check campaign status for current event
    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=GET-CAMPAIGN-STATUS&eventid=${eventid}`,
      {
        withCredentials: true,
      },
    ).then((res) => {
      setCheckCampaignStatus(res.data.campaign_status ?? 'stop')
    })

    // Fetch VVIP ticket details
    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=GETVVIPDETAILS&accountid=${businessid}&eventid=${eventid}`,
      { withCredentials: true },
    ).then((res) => {
      setGetVVIP(res.data.vvipticketavail ?? 0)
      setGetVVIPprice(res.data.vvipprice ?? 0)
      setKidsPrice(res.data.kids_vvip_price ?? 0)
      setKidsTickets(res.data.kids_vvip_tickets ?? 0)

      setSelectedTicket(0)
      setSelectedPrice(res.data.genprice ?? res.data.vvipprice)
      setKidsSelectedPrice(res.data.kids_price ?? res.data.kids_vvip_price)
      setKidsSelectedTicket(0)
    })

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=GETVIPDETAILS&accountid=${businessid}&eventid=${eventid}`,
      { withCredentials: true },
    ).then((res) => {
      setGetVIP(res.data.vipticketavail ?? 0)
      setGetVIPprice(res.data.vipprice ?? 0)
      setKidsVipPrice(res.data.kids_vip_price ?? 0)
      setKidsVipTickets(res.data.kids_vip_tickets ?? 0)
    })

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=GETGENDETAILS&accountid=${businessid}&eventid=${eventid}`,
      { withCredentials: true },
    ).then((res) => {
      setGetGen(res.data.genticketavail ?? 0)
      setGetGENprice(res.data.genprice ?? 0)
      setKidsGeneralPrice(res.data.kids_general_price ?? 0)
      setKidsGeneralTickets(res.data.kids_general_tickets ?? 0)
    })

    // Complimentary codes created for this event.
    // Expected: { status:'success', codes:[{ code, tier, label, allocated, used, max_per_order }] }
    Axios.get(`${baseURL}?query=SPONSOR-CODES-LIST&event_id=${eventid}`, {
      withCredentials: true,
    })
      .then((res) => setSponsorCodes(res.data.status === 'success' ? res.data.codes || [] : []))
      .catch(() => setSponsorCodes([]))

    // Refunds total for this event (the old "completed" and "pending" amounts are gone:
    // completed included booking fees, which belong to Karamale)
    Axios.get(`${baseURL}?query=TRANSACTION-AMOUNTS&event_id=${eventid}`, {
      withCredentials: true,
    })
      .then((res) => setSales({ refunds: res.data.refundedAmt }))
      .catch((err) => console.error('Error fetching sales:', err))

    // Gross and net come from the same list the dashboard uses, so both pages always agree
    Axios.get(`${baseURL}?query=EVENT-LIST`, { withCredentials: true })
      .then((res) => {
        if (res.data.status !== 'success') return
        const ev = (res.data.events || []).find((e) => String(e.eventid) === String(eventid))
        if (!ev) return
        const gross = toNum(ev.sales)
        setEventMoney({ gross, net: gross - toNum(ev.net) })
      })
      .catch((err) => console.error('Error fetching event totals:', err))

    Axios.get(`${baseURL}?query=TRANSACTIONS-LIST&event_id=${eventid}`, {
      withCredentials: true,
    })
      .then((res) => {
        setTxns(res.data.status === 'success' ? res.data.transactions : [])
        setTxLoaded(true)
      })
      .catch(() => {
        setTxns([])
        setTxLoaded(true)
      })

    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)

    return () => {
      window.removeEventListener('resize', updateIsMobile)
    }
  }, [count, eventid, eventname, event_date, deleted, checkcampaign, checkposter, checktickets])

  const reprint = () => {
    const eventid = props.location.state.eventid
    const eventname = props.location.state.eventname
    localStorage.setItem('eventid', eventid)
    localStorage.setItem('eventname', eventname)
    history.push({
      pathname: '/download',
      state: {
        reprint: 'yes',
      },
    })
  }

  const delModal = () => {
    setDeleteModal(true)
  }

  const addAPoster = () => {
    setAddPoster(true)
  }

  const activateVVIP = () => {
    setCurrentSelect('VVIP')
    setSelectedTicket(0)
    setSelectedPrice(getVVIPprice)
    setKidsSelectedPrice(kids_price)
    setKidsSelectedTicket(0)
  }

  const activateGen = () => {
    setCurrentSelect('General')
    setSelectedTicket(0)
    setSelectedPrice(getGENprice)
    setKidsSelectedPrice(kids_general_price)
    setKidsSelectedTicket(0)
  }

  const activateVIP = () => {
    setCurrentSelect('VIP')
    setSelectedTicket(0)
    setSelectedPrice(Number(getVIPprice))
    setKidsSelectedPrice(Number(kids_vip_price))
    setKidsSelectedTicket(0)
  }

  const copyText = (key, text) => {
    if (!text || !navigator.clipboard) return
    navigator.clipboard.writeText(text).then(() => {
      setCopied(key)
      setTimeout(() => setCopied(''), 2000)
    })
  }

  const handleTickets = (event) => {
    setSelectedTicket(event.target.value)
    setErrorDisplay('none')
    setFormMsg(null)
  }

  const handlePrice = (event) => {
    setSelectedPrice(event.target.value)
    setErrorDisplay('none')
    setFormMsg(null)
  }

  const handle_kids_tickets = (event) => {
    setKidsSelectedTicket(event.target.value)
    setErrorDisplay('none')
    setFormMsg(null)
  }

  const handle_kids_price = (event) => {
    setKidsSelectedPrice(event.target.value)
    setErrorDisplay('none')
    setFormMsg(null)
  }

  const closeModal = () => {
    if (isComp) resetComp()
    setShowModal(false)
    setDeleteModal(false)
    setAddPoster(false)
    setControlModal(false)
    setPostponeEvent(false)
    setResumeModal(false)
    setErrorDisplay('none')
    setFormMsg(null)
  }

  const openModal = () => {
    setShowModal(true)
    setCancelTitle('Cancel')
    setFormMsg(null)
  }

  // Back to the normal (paid) form for the current tier
  const resetComp = () => {
    setIsComp(false)
    setCompCode('')
    setCompLabel('')
    setCompTopUp('')
    setCompLoaded(null)
    setFormMsg(null)
    if (currentSelect === 'VVIP') activateVVIP()
    else if (currentSelect === 'VIP') activateVIP()
    else activateGen()
  }

  const toggleComp = (checked) => {
    setErrorDisplay('none')
    setFormMsg(null)
    if (checked) {
      setIsComp(true)
      setCompCode('')
      setCompLabel('')
      setCompTopUp('')
      setCompLoaded(null)
      setSelectedTicket(0)
      setKidsSelectedTicket(0)
      setSelectedPrice(0)
      setKidsSelectedPrice(0)
    } else {
      resetComp()
    }
  }

  // Switching tier while complimentary keeps prices at R0.
  // A code belongs to one tier, so any selected/saved code is cleared.
  const selectTier = (activate) => {
    activate()
    setFormMsg(null)
    if (isComp) {
      setSelectedPrice(0)
      setKidsSelectedPrice(0)
      setCompTopUp('')
      if (compLoaded) {
        setCompLoaded(null)
        setCompCode('')
        setCompLabel('')
      }
    }
  }

  // Pick an existing code to top up (or '' for a brand-new code)
  const handleTopUp = (code) => {
    setCompTopUp(code)
    setFormMsg(null)
    const c = sponsorCodes.find((x) => x.code === code)
    setCompLabel(c?.label || '')
    if (c?.max_per_order) setCompMaxPerOrder(c.max_per_order)
  }

  // After a save: start another allocation (new code generated by the server on save)
  const startAnother = () => {
    setCompLoaded(null)
    setCompLabel('')
    setCompCode('')
    setCompTopUp('')
    setSelectedTicket(0)
    setKidsSelectedTicket(0)
    setSelectedPrice(0)
    setKidsSelectedPrice(0)
    setFormMsg(null)
  }

  const cancel = () => {
    if (isComp) resetComp()
    setShowModal(false)
    setDeleteModal(false)
    setControlModal(false)
    setResumeModal(false)
    setErrorDisplay('none')
    setFormMsg(null)
  }

  // Inline error inside the Load tickets dialog
  const failUpdate = (msg) => {
    setFormMsg({ type: 'error', text: String(msg) })
    setUpdateDisplay('block')
    setSpinning('none')
    setLoadBarProgress(false)
  }

  const update = async () => {
    const { eventid } = location.state || {}
    setFormMsg(null)

    // Complimentary tickets are always R0. Don't trust state that a refetch may have overwritten.
    const price = isComp ? 0 : selectedPrice
    const kidsPrice = isComp ? 0 : kidsSelectedPrice
    const category = currentSelect.toLowerCase()

    const adultsN = Number(selectedTicket === '' ? 0 : selectedTicket)
    const kidsN = Number(kidsSelectedTicket === '' ? 0 : kidsSelectedTicket)
    const totalTickets = adultsN + kidsN

    const badQty = (n) => !Number.isInteger(n) || n < 0
    const priceInvalid = (p) => String(p).trim() === '' || isNaN(p) || Number(p) < 0
    const priceZero = (p) => !isComp && Number(p) === 0

    if (badQty(adultsN) || badQty(kidsN)) {
      failUpdate('Ticket quantities must be whole numbers (0 or more).')
    } else if (totalTickets <= 0) {
      failUpdate('Enter how many tickets to load.')
    } else if (priceInvalid(price)) {
      failUpdate('Invalid ticket price for Adults.')
    } else if (adultsN > 0 && priceZero(price)) {
      failUpdate('Adult price cannot be R0. Tick "Complimentary" for free tickets.')
    } else if (priceInvalid(kidsPrice)) {
      failUpdate('Invalid ticket price for Kids.')
    } else if (kidsN > 0 && priceZero(kidsPrice)) {
      failUpdate('Kids price cannot be R0. Tick "Complimentary" for free tickets.')
    } else if (isComp && !(Number(compMaxPerOrder) >= 1)) {
      failUpdate('Max per order must be at least 1.')
    } else if (isComp && !compTopUp && Number(compMaxPerOrder) > totalTickets) {
      failUpdate("Max per order can't be more than the tickets you're allocating.")
    } else {
      setUpdateDisplay('none')
      setSpinning('block')
      setLoadBarProgress(true)

      const dataForm = new FormData()
      dataForm.append('query', 'ADDTICEKTS')
      dataForm.append('eventid', eventid)
      dataForm.append('category', category)
      dataForm.append('price', price)
      dataForm.append('numberOftickets', adultsN)
      dataForm.append('kids_price', kidsPrice)
      dataForm.append('kids_tickets', kidsN)
      dataForm.append('is_complimentary', isComp ? 1 : 0)
      dataForm.append('max_per_order', isComp ? compMaxPerOrder : 0)
      // Empty = server generates a new code. A code = top up that existing pool.
      dataForm.append('sponsor_code', isComp ? compTopUp : '')
      dataForm.append('sponsor_label', isComp && !compTopUp ? compLabel.trim() : '')

      try {
        const response = await Axios({
          method: 'POST',
          url: baseURL,
          data: dataForm,
          withCredentials: true,
        })
        const data = response.data

        // PHP warnings / login redirects can come back as HTML or a string
        if (!data || typeof data !== 'object') {
          failUpdate('Unexpected response from the server. Please try again.')
          return
        }
        if (data.status !== 'success') {
          failUpdate(data.message || data.error || "We couldn't load your tickets.")
          return
        }

        setCount((c) => c + 1) // refresh codes list + ticket counts
        setFormMsg({ type: 'success', text: data.message || 'Tickets loaded.' })
        setUpdateDisplay('block')
        setSpinning('none')
        setLoadBarProgress(false)
        setCancelTitle('Done')

        if (isComp) {
          // The code comes from the server
          setCompCode(data.sponsor_code || compTopUp || '')
          setCompLoaded(currentSelect)
        } else {
          setChecktickets('yes')
          setSelectedTicket(0) // avoid accidental double submit
          setKidsSelectedTicket(0)
        }
      } catch (error) {
        console.error('ADDTICEKTS request failed:', error)
        failUpdate(
          error.response?.data?.message ||
            error.message ||
            "We couldn't load your tickets. Please check your connection and try again.",
        )
      }
    }
  }

  const deleteEvent = () => {
    const { eventid } = location.state || {}
    const data = new FormData()
    data.append('eventid', eventid)
    data.append('query', 'DELETEEVENT')

    Axios({
      method: 'POST',
      url: baseURL,
      data: data,
      withCredentials: true,
    })
      .then((response) => {
        if (response.data.status === 'success') {
          history.goBack()
        } else {
          setError(response.data.message || 'Something went wrong.')
          setErrorDisplay('block')
          setSuccessError('error-login')
          setUpdateDisplay('block')
          setSpinning('none')
        }
      })
      .catch((error) => {
        const message =
          error.response?.data?.message ||
          "We couldn't complete your request. Please check your connection or try again shortly."
        setError(message)
        setErrorDisplay('block')
        setSuccessError('error-login')
        setUpdateDisplay('block')
        setSpinning('none')
      })

    setTimeout(() => {
      setUpdateDisplay('none')
    }, 5000)
  }

  const functionControl = () => {
    if (checkcampaign == 'no') {
      setControlModal(true)
      setDelString('You have to create a campaign first')
    } else if (deleted == 1) {
      setControlModal(true)
      setDelString("This event has been deleted, it can't be edited")
    } else {
      setControlModal(true)
      setDelString("This event has already passed, it can't be edited")
    }
  }

  const campaign = () => {
    const s = props.location.state
    history.push({
      pathname: 'campaign',
      state: {
        eventid: s.eventid,
        eventname: s.eventname,
        poster: s.poster,
        eventdate: s.eventdate,
        enddate: s.enddate,
        event_date: s.event_date,
        finish_date: s.finish_date,
        theme: s.theme,
        venue: s.venue,
        expectednum: s.expectednum,
        time: s.time,
        endtime: s.endtime,
        prevpage: s.prevpage,
        currentpage: 'editevent',
      },
    })
  }

  const selectImage = (event) => {
    const img = event.target.files[0]
    if (!img) return
    const previewURL = URL.createObjectURL(img)

    setImage(previewURL)
    setPreimage(previewURL)
    setImgname(img)
    setHideUploadBtn('block')
  }

  const uploadPoster = async () => {
    const eventid = props.location.state.eventid
    const accountid = localStorage.getItem('businessid')
    let data = new FormData()
    setUpdateDisplay('none')
    setSpinning('block')

    data.append('file', imgname)
    data.append('eventid', eventid)
    data.append('businessid', accountid)
    data.append('query', 'POSTERUPLOAD')

    if (image === '') {
      setError('Please select a poster')
      setErrorDisplay('block')
      setSuccessError('error-login')
      setUpdateDisplay('block')
      setSpinning('none')
    } else {
      await Axios({
        url: `${API_URL}/apps/kscanner/webservices.php`,
        method: 'POST',
        data: data,
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then((response) => {
          setError(response.data.message)
          setErrorDisplay('block')
          setSuccessError(response.data.status === 'success' ? 'success-alert' : 'error-alert')
          setUpdateDisplay('block')
          setSpinning('none')
          setAddPoster(false)
          setCheckposter('yes')
          setLoadBarProgress(false)
          setShowModal(false)
          setDeleteModal(false)
          setControlModal(false)
          setPostponeEvent(false)
          setResumeModal(false)
        })
        .catch((error) => {
          console.log('image upload error: ', error)
          setUpdateDisplay('block')
          setSpinning('none')
          setLoadBarProgress(false)
          setError("We couldn't upload the poster. Please try again.")
          setErrorDisplay('block')
          setSuccessError('error-login')
        })

      setTimeout(() => {
        setErrorDisplay('none')
      }, 4000)

      history.push({
        pathname: '/editevent',
        state: {
          campaignstatus,
          eventid,
          eventname,
          poster,
          eventdate,
          enddate,
          event_date,
          finish_date,
          theme,
          venue,
          expectednum,
          time,
          endtime,
          prevpage,
        },
      })
    }
  }

  const postpone = () => {
    setPostponeEvent(true)
    setSubtype('postpone')
    setActionBtn('Confirm Postponement')
  }

  const cancelModal = () => {
    setPostponeEvent(true)
    setSubtype('cancel')
    setActionBtn('Confirm Cancellation')
  }

  const handleMessage = (event) => {
    setMessage(event.target.value)
    setErrorDisplay('none')
  }

  const postponeTheEvent = () => {
    const eventid = props.location.state.eventid
    const businessid = localStorage.getItem('businessid')
    const type = subtype

    if (reason === '') {
      setError('Select a reason for the postponement ')
      setErrorDisplay('block')
      setSuccessError('error-login')
    } else if (message.trim() === '') {
      setError('Write a message ')
      setErrorDisplay('block')
      setSuccessError('error-login')
    } else {
      setSpinning('block')
      const data = new FormData()
      data.append('query', 'POSTPONE')
      data.append('businessid', businessid)
      data.append('eventid', eventid)
      data.append('type', type)
      data.append('message', message)
      data.append('reason', reason)

      Axios.post(`${API_URL}/apps/kscanner/webservices.php`, data, {
        withCredentials: true,
      })
        .then((response) => {
          if (response.data.status === 'success') {
            setCount(count + 1)
            setError(response.data.message)
            setErrorDisplay('block')
            setSuccessError('success-login')

            setShowModal(false)
            setDeleteModal(false)
            setPostponeEvent(false)
          } else {
            setError(response.data.message)
            setErrorDisplay('block')
            setSuccessError('error-login')
          }

          setTimeout(() => {
            setErrorDisplay('none')
          }, 6000)
          setSpinning('none')
        })
        .catch((err) => {
          setError(err)
          setErrorDisplay('block')
          setSuccessError('error-login')

          setTimeout(() => {
            setErrorDisplay('none')
          }, 6000)
          setSpinning('none')
        })
    }
  }

  const resumeAModal = () => {
    setResumeModal(true)
  }

  const resumeCampaign = () => {
    const eventid = props.location.state.eventid
    const accountid = localStorage.getItem('businessid')

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=RESUMECAMPAIGN&eventid=${eventid}&businessid=${accountid}`,
      { withCredentials: true },
    )
      .then((response) => {
        if (response.data.status === 'failed') {
          setResumeModal(false)
          setCount(count + 1)
          setError(response.data.message)
          setErrorDisplay('block')
          setSuccessError('error-login')
        } else {
          setResumeModal(false)
          setCount(count + 1)
          setError(response.data.message)
          setErrorDisplay('block')
          setSuccessError(response.data.status === 'stop' ? 'error-login' : 'success-login')
        }
      })
      .catch((error) => {
        setError(error)
        setErrorDisplay('block')
        setSuccessError('error-login')
      })

    setTimeout(() => {
      setErrorDisplay('none')
    }, 4000)
  }

  const downloadTickets = () => {
    const s = props.location.state
    localStorage.setItem('eventname', s.eventname)
    localStorage.setItem('download', 'download')
    localStorage.setItem('eventid', s.eventid)
    history.push({
      pathname: '/downloadtickets',
      state: {
        eventid: s.eventid,
        eventname: s.eventname,
        poster: s.poster,
        eventdate: s.eventdate,
        enddate: s.enddate,
        event_date: s.event_date,
        finish_date: s.finish_date,
        theme: s.theme,
        venue: s.venue,
        expectednum: s.expectednum,
        time: s.time,
        endtime: s.endtime,
        prevpage: s.prevpage,
        currentpage: 'editevent',
      },
    })
  }

  if (localStorage.getItem('businessid') === null) {
    return <Redirect to="/login" />
  }

  const handleToggle = () => {
    setCollapsed((prev) => !prev)
  }

  // ---- derived state ----
  const fulldate = new Date().toLocaleDateString('en-CA') // YYYY-MM-DD, local time
  const isLive = event_date >= fulldate && deleted == 0
  const ticketsReady = checktickets === 'yes'
  const posterReady = checkposter === 'yes'
  const canDownload = isLive && ticketsReady && posterReady && checkcampaign === 'yes'
  const cancelledOrPostponed = cancelledAt != null
  const paused = checkCampaignStatus === 'stop'
  const notPublished = checkcampaign === 'no'
  const statusString = paused ? 'Resume campaign' : 'Pause campaign'
  const busy = spinning === 'block'
  const hasPoster = preimage && preimage !== 'none'
  const purchaseLink = eventid ? `${PURCHASE_BASE}/event/${eventid}/tickets` : ''
  const toastType = String(successError).includes('error')
    ? 'error'
    : String(successError).includes('warning')
      ? 'warning'
      : 'success'

  const whenLabel = (() => {
    if (!deletion || deletion.tone !== 'scheduled' || !event_date) return ''
    const start = new Date(`${event_date}T00:00:00`)
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const days = Math.round((start - today) / 86400000)
    if (Number.isNaN(days) || days < 0) return ''
    if (days === 0) return 'Today'
    if (days === 1) return 'Tomorrow'
    return `In ${days} days`
  })()
  const multiDay = Boolean(event_date && finish_date && finish_date !== event_date)

  const steps = [
    {
      key: 'tickets',
      title: 'Load tickets',
      hint: ticketsReady ? 'Tickets are loaded. Top up any time.' : 'Set prices and quantities',
      done: ticketsReady,
      icon: <IoTicketOutline />,
      onClick: isLive ? openModal : functionControl,
    },
    {
      key: 'poster',
      title: 'Upload poster',
      hint: posterReady ? 'Poster is uploaded' : 'Add the poster buyers will see',
      done: posterReady,
      icon: <IoImageOutline />,
      onClick: isLive ? addAPoster : functionControl,
    },
    {
      key: 'publish',
      title: 'Publish event',
      hint: notPublished ? 'Create a campaign to go live' : 'Campaign created',
      done: !notPublished,
      icon: <IoRocketOutline />,
      onClick: isLive && ticketsReady && posterReady ? campaign : functionControl,
    },
    {
      key: 'download',
      title: 'Download tickets',
      hint: ticketCount > 0 ? 'Tickets downloaded' : 'Get your printable tickets',
      done: ticketCount > 0,
      icon: <IoCloudDownloadOutline />,
      onClick: canDownload ? downloadTickets : functionControl,
    },
  ]
  const doneCount = steps.filter((s) => s.done).length

  const statusOf = (t) => String(t.payment_status || '').toLowerCase()
  const completeTxns = txns.filter((t) => statusOf(t) === 'complete')
  const countStatus = (s) => txns.filter((t) => statusOf(t) === s).length
  const admissionsTotal = completeTxns.reduce((sum, t) => sum + (Number(t.admissions) || 0), 0)

  // Per-tier sold + revenue. Transaction amounts include Karamale's booking fee, so each tier's
  // share of completed payments is scaled to the event's gross (which excludes the fee).
  const completedPaidTotal = completeTxns.reduce((sum, t) => sum + toNum(t.amount_gross), 0)
  const eventGross = eventMoney ? eventMoney.gross : null
  const feeFactor =
    eventGross == null ? null : completedPaidTotal > 0 ? eventGross / completedPaidTotal : 0
  const tierStats = TIER_NAMES.map((name) => {
    const rows = completeTxns.filter((t) => tierOf(t.ticket_type) === name)
    const paid = rows.reduce((sum, t) => sum + toNum(t.amount_gross), 0)
    return { name, sold: rows.length, revenue: feeFactor == null ? null : paid * feeFactor }
  })
  const tierSoldTotal = tierStats.reduce((sum, t) => sum + t.sold, 0)
  const tierRevenueTotal =
    feeFactor == null ? null : tierStats.reduce((sum, t) => sum + (t.revenue || 0), 0)

  // Complimentary allocation per tier (from the codes list)
  const compStats = TIER_NAMES.reduce((acc, name) => {
    const rows = sponsorCodes.filter((c) => tierOf(c.tier) === name)
    acc[name] = {
      allocated: rows.reduce((sum, c) => sum + (Number(c.allocated) || 0), 0),
      used: rows.reduce((sum, c) => sum + (Number(c.used) || 0), 0),
    }
    return acc
  }, {})

  // Live explanation of what "max per order" means for the allocation being typed
  // Existing codes for the selected tier (for topping up)
  const topUpOptions = sponsorCodes.filter((c) => tierOf(c.tier) === tierOf(currentSelect))

  const compTotal = Number(selectedTicket || 0) + Number(kidsSelectedTicket || 0)
  const compMax = Number(compMaxPerOrder)
  const compSummary =
    compTotal > 0 && compMax >= 1
      ? compTopUp
        ? `${compTotal} more tickets will be added to ${compTopUp}. Holders can buy up to ${compMax} per order.`
        : `${compTotal} tickets are allocated to this code. Holders can buy up to ${compMax} per order, and can order again until all ${compTotal} are claimed (at least ${Math.ceil(
            compTotal / compMax,
          )} orders). Unclaimed tickets stay reserved for this code only.`
      : 'Set how many tickets to allocate and the most one person can take per order.'

  const sortedTxns = [...txns].sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
  const recentTxns = sortedTxns.slice(0, 5)
  const txQuery = txSearch.trim().toLowerCase()
  const filteredTxns = sortedTxns.filter((t) => {
    if (txFilter !== 'ALL' && t.payment_status.toUpperCase() !== txFilter) return false
    const d = String(t.created_at || '').slice(0, 10)
    if (txFrom && d < txFrom) return false
    if (txTo && d > txTo) return false
    if (
      txQuery &&
      ![t.name_first, t.transaction_id, t.ticket_type].some((v) =>
        String(v ?? '')
          .toLowerCase()
          .includes(txQuery),
      )
    )
      return false
    return true
  })
  const txFiltersActive = txFilter !== 'ALL' || txFrom || txTo || txQuery
  const filteredCompleteTotal = filteredTxns
    .filter((t) => t.payment_status.toLowerCase() === 'complete')
    .reduce((sum, t) => sum + (Number(t.amount_gross) || 0), 0)
  const clearTxFilters = () => {
    setTxSearch('')
    setTxFrom('')
    setTxTo('')
    setTxFilter('ALL')
    setTxPage(1)
  }
  const txPages = Math.max(1, Math.ceil(filteredTxns.length / txPerPage))
  const pagedTxns = filteredTxns.slice((txPage - 1) * txPerPage, txPage * txPerPage)

  const routeState = {
    campaignstatus,
    eventid,
    eventname,
    poster,
    eventdate,
    enddate,
    event_date,
    finish_date,
    theme,
    venue,
    expectednum,
    time,
    endtime,
    prevpage,
  }

  const tiers = [
    {
      name: 'VVIP',
      adultsLoaded: Number(getVVIP) || 0,
      adultsPrice: getVVIPprice,
      kidsLoaded: Number(kids_tickets) || 0,
      kidsPrice: kids_price,
      onSelect: activateVVIP,
      adults: `${getVVIP} loaded · R${getVVIPprice}`,
      kids: `${kids_tickets} loaded · R${kids_price}`,
    },
    {
      name: 'VIP',
      adultsLoaded: Number(getVIP) || 0,
      adultsPrice: getVIPprice,
      kidsLoaded: Number(kids_vip_tickets) || 0,
      kidsPrice: kids_vip_price,
      onSelect: activateVIP,
      adults: `${getVIP} loaded · R${getVIPprice}`,
      kids: `${kids_vip_tickets} loaded · R${kids_vip_price}`,
    },
    {
      name: 'General',
      adultsLoaded: Number(getGen) || 0,
      adultsPrice: getGENprice,
      kidsLoaded: Number(kids_general_tickets) || 0,
      kidsPrice: kids_general_price,
      onSelect: activateGen,
      adults: `${getGen} loaded · R${getGENprice}`,
      kids: `${kids_general_tickets} loaded · R${kids_general_price}`,
    },
  ]

  return (
    <div className="view">
      {loadBarProgress && <TopBarProgress />}
      <Header />
      <SideNav collapsed={collapsed} onToggle={handleToggle} />

      <div
        className="main-content ee-page"
        style={{
          marginTop: 'var(--header-h)',
          marginLeft: isMob ? '0px' : collapsed ? '76px' : '252px',
        }}
      >
        {isMobile && !collapsed && <div className="mobile-overlay active" onClick={handleToggle} />}
        {isMob && collapsed && (
          <label className="mobile-toggle" onClick={handleToggle}>
            <BiMenu size={25} />
          </label>
        )}

        {/* ---------- Top bar ---------- */}
        <div className="ee-topbar">
          <button type="button" className="ee-back" onClick={() => history.goBack()}>
            <IoChevronBack size={18} /> Back
          </button>

          {!cancelledOrPostponed && (
            <Link
              className="ee-btn ee-btn-ghost"
              to={{
                pathname: 'updateeventdetails',
                state: { ...routeState, currentage: 'editevent' },
              }}
            >
              <IoPencilOutline size={16} /> Edit details
            </Link>
          )}
        </div>

        {is_sponsorship == true && (
          <div className="ee-sponsor">
            <IoStar /> Tickets to this event are proudly sponsored by Karamale.
          </div>
        )}

        <div className="ee-grid">
          {/* ---------- Main column ---------- */}
          <div className="ee-main">
            <section className="ee-card eeh">
              <div className="eeh-poster">
                {hasPoster ? (
                  <img src={preimage} alt={eventname} />
                ) : (
                  <button
                    type="button"
                    className="eeh-poster-empty"
                    onClick={isLive ? addAPoster : functionControl}
                  >
                    <IoImageOutline size={34} />
                    <span>No poster yet</span>
                    {isLive && <small>Click to upload</small>}
                  </button>
                )}
              </div>

              <div className="eeh-body">
                <div className="eeh-top">
                  {deletion && (
                    <span className={`eeh-chip eeh-chip-${deletion.tone}`}>
                      <i />
                      {STATUS_LABELS[deletion.tone]}
                    </span>
                  )}
                  {whenLabel && <span className="eeh-when">{whenLabel}</span>}
                </div>

                <h1 className="eeh-title">{eventname}</h1>
                {deletion && <p className="eeh-status">{deletion.text}</p>}

                <dl className="eeh-meta">
                  {eventdate && (
                    <div className="eeh-item">
                      <span className="eeh-ico">
                        <IoCalendarOutline />
                      </span>
                      <div>
                        <dt>Date</dt>
                        <dd>
                          {eventdate}
                          {multiDay && enddate ? ` – ${enddate}` : ''}
                        </dd>
                      </div>
                    </div>
                  )}
                  {time && (
                    <div className="eeh-item">
                      <span className="eeh-ico">
                        <IoTimeOutline />
                      </span>
                      <div>
                        <dt>Time</dt>
                        <dd>
                          {time}
                          {endtime ? ` – ${endtime}` : ''}
                        </dd>
                      </div>
                    </div>
                  )}
                  {venue && (
                    <div className="eeh-item">
                      <span className="eeh-ico">
                        <IoLocationOutline />
                      </span>
                      <div>
                        <dt>Venue</dt>
                        <dd>{venue}</dd>
                      </div>
                    </div>
                  )}
                  {expectednum && (
                    <div className="eeh-item">
                      <span className="eeh-ico">
                        <IoPeopleOutline />
                      </span>
                      <div>
                        <dt>Expected guests</dt>
                        <dd>{expectednum}</dd>
                      </div>
                    </div>
                  )}
                </dl>

                {purchaseLink && (
                  <div className="eeh-link">
                    <span className="eeh-ico">
                      <IoLinkOutline />
                    </span>
                    <div className="eeh-link-body">
                      <span className="eeh-link-label">Ticket purchase link</span>
                      <a
                        className="eeh-link-url"
                        href={purchaseLink}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {purchaseLink}
                      </a>
                      {notPublished && (
                        <span className="eeh-link-hint">
                          Publish the event before sharing. Buyers can't see it yet.
                        </span>
                      )}
                    </div>
                    <div className="eeh-link-actions">
                      <button
                        type="button"
                        className="ee-btn ee-btn-ghost"
                        onClick={() => copyText('link', purchaseLink)}
                      >
                        {copied === 'link' ? (
                          <IoCheckmark size={16} />
                        ) : (
                          <IoCopyOutline size={16} />
                        )}{' '}
                        {copied === 'link' ? 'Copied' : 'Copy'}
                      </button>
                      <a
                        className="ee-btn ee-btn-ghost"
                        href={purchaseLink}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <IoOpenOutline size={16} /> Open
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </section>

            <section className="ee-card">
              <div className="ee-card-head">
                <h2>Sales</h2>
              </div>
              <div className="ees-wrap">
                <div className="ees-viewport">
                  <div
                    className="ees-track"
                    style={{ transform: `translateX(-${salesPage * 100}%)` }}
                  >
                    <dl className="ees-page" aria-hidden={salesPage !== 0}>
                      <Stat
                        tone="blue"
                        icon={<IoCashOutline />}
                        label="Gross"
                        value={eventMoney ? formatToZAR(eventMoney.gross) : '—'}
                        hint="Ticket sales before fees"
                      />
                      <Stat
                        tone="green"
                        icon={<IoTrendingUpOutline />}
                        label="Net"
                        value={eventMoney ? formatToZAR(eventMoney.net) : '—'}
                        hint="Gross minus fees"
                      />
                      <Stat
                        tone="violet"
                        icon={<IoTicketOutline />}
                        label="Tickets sold"
                        value={completeTxns.length}
                        hint="Completed purchases"
                      />
                      <Stat
                        tone="cyan"
                        icon={<IoPeopleOutline />}
                        label="Admissions"
                        value={admissionsTotal}
                        hint="Entries across sold tickets"
                      />
                      <Stat
                        tone="orange"
                        icon={<IoReturnDownBackOutline />}
                        label="Refunds"
                        value={formatToZAR(sales.refunds)}
                        hint="Money returned to buyers"
                      />
                    </dl>

                    <dl className="ees-page is-three" aria-hidden={salesPage !== 1}>
                      <Stat
                        tone="amber"
                        icon={<IoHourglassOutline />}
                        label="Pending"
                        value={countStatus('pending')}
                        hint="Payment started, not yet confirmed"
                      />
                      <Stat
                        tone="red"
                        icon={<IoCloseCircleOutline />}
                        label="Cancelled"
                        value={countStatus('cancelled')}
                        hint="Buyer cancelled the payment"
                      />
                      <Stat
                        tone="slate"
                        icon={<IoRemoveCircleOutline />}
                        label="Abandoned"
                        value={countStatus('abandoned')}
                        hint="Buyer left without paying"
                      />
                    </dl>
                  </div>
                </div>

                <button
                  type="button"
                  className="ees-nav"
                  onClick={() => setSalesPage((p) => (p === 0 ? 1 : 0))}
                  aria-label={salesPage === 0 ? 'Show unpaid transactions' : 'Back to sales'}
                >
                  {salesPage === 0 ? <IoChevronForward size={18} /> : <IoChevronBack size={18} />}
                </button>
              </div>
            </section>

            <section className="ee-card">
              <div className="ee-card-head">
                <h2>Tickets</h2>
                {isLive && (ticketsReady || sponsorCodes.length > 0) && (
                  <button type="button" className="ee-linkbtn" onClick={openModal}>
                    Top up
                  </button>
                )}
              </div>
              {ticketsReady ? (
                <>
                  <p className="eet-summary">
                    <strong>{tierSoldTotal}</strong> tickets sold <span>·</span>{' '}
                    <strong>
                      {tierRevenueTotal == null ? '—' : formatToZAR(tierRevenueTotal)}
                    </strong>{' '}
                    gross
                  </p>

                  {tierSoldTotal > 0 && (
                    <div className="eet-bar" role="img" aria-label="Share of tickets sold by type">
                      {tierStats.map((st) =>
                        st.sold > 0 ? (
                          <span
                            key={st.name}
                            className={`eet-seg eet-tone-${st.name.toLowerCase()}`}
                            style={{ width: `${(st.sold / tierSoldTotal) * 100}%` }}
                            title={`${st.name}: ${st.sold} sold`}
                          />
                        ) : null,
                      )}
                    </div>
                  )}

                  <div className="eet-grid">
                    {tiers.map((t) => {
                      const st = tierStats.find((x) => x.name === t.name)
                      const comp = compStats[t.name]
                      return (
                        <article
                          key={t.name}
                          className={`eet-card eet-tone-${t.name.toLowerCase()}`}
                        >
                          <header>
                            <span className="eet-badge">{t.name}</span>
                            <span className="eet-sold">{st.sold} sold</span>
                          </header>
                          <div className="eet-rev">
                            <span>Revenue</span>
                            <strong>{st.revenue == null ? '—' : formatToZAR(st.revenue)}</strong>
                          </div>
                          <dl className="eet-lines">
                            <div>
                              <dt>Adults</dt>
                              <dd>
                                <strong>{t.adultsLoaded}</strong> loaded <span>·</span>{' '}
                                {formatToZAR(t.adultsPrice)}
                              </dd>
                            </div>
                            <div>
                              <dt>Kids</dt>
                              <dd>
                                <strong>{t.kidsLoaded}</strong> loaded <span>·</span>{' '}
                                {formatToZAR(t.kidsPrice)}
                              </dd>
                            </div>
                          </dl>
                          {comp.allocated > 0 && (
                            <p className="eet-comp-line">
                              Complimentary: <strong>{comp.allocated - comp.used}</strong> left of{' '}
                              {comp.allocated}
                            </p>
                          )}
                        </article>
                      )
                    })}
                  </div>
                </>
              ) : (
                <p className="ee-empty">
                  No tickets loaded yet.{' '}
                  {isLive && (
                    <button type="button" className="ee-linkbtn" onClick={openModal}>
                      Load tickets
                    </button>
                  )}
                </p>
              )}
            </section>

            {sponsorCodes.length > 0 && (
              <section className="ee-card">
                <div className="ee-card-head">
                  <h2>Complimentary codes</h2>
                  <span className="ee-count">{sponsorCodes.length}</span>
                </div>
                <p className="eec-note">
                  Hidden from the public. Share a code only with the people it's meant for. They
                  enter it on the purchase page under "Sponsored ticket".
                </p>
                <div className="ee-table-scroll">
                  <table className="ee-table">
                    <thead>
                      <tr>
                        <th>Code</th>
                        <th>Type</th>
                        <th>For</th>
                        <th className="ee-r">Claimed</th>
                        <th className="ee-r">Max / order</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sponsorCodes.map((c) => {
                        const left = (Number(c.allocated) || 0) - (Number(c.used) || 0)
                        return (
                          <tr key={c.code}>
                            <td>
                              <span className="eec-code">
                                {c.code}
                                <button
                                  type="button"
                                  className="eec-copy"
                                  aria-label={`Copy code ${c.code}`}
                                  onClick={() => copyText(`row-${c.code}`, c.code)}
                                >
                                  {copied === `row-${c.code}` ? (
                                    <IoCheckmark size={16} />
                                  ) : (
                                    <IoCopyOutline size={16} />
                                  )}
                                </button>
                              </span>
                            </td>
                            <td className="ee-cap">{String(c.tier || '').toLowerCase()}</td>
                            <td>{c.label || <span className="ee-muted">—</span>}</td>
                            <td className="ee-r">
                              <strong>{Number(c.used) || 0}</strong> / {Number(c.allocated) || 0}
                              <div className="eec-left">{left} left</div>
                            </td>
                            <td className="ee-r">{c.max_per_order}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </section>
            )}

            <section className="ee-card">
              <div className="ee-card-head">
                <h2>Recent transactions</h2>
                {txns.length > 0 && (
                  <button type="button" className="ee-linkbtn" onClick={() => setTxModal(true)}>
                    View all ({txns.length})
                  </button>
                )}
              </div>
              {!txLoaded ? (
                <p className="ee-empty">
                  <ClipLoader size={18} color="grey" />
                </p>
              ) : recentTxns.length === 0 ? (
                <p className="ee-empty">No transactions yet. Sales will appear here.</p>
              ) : (
                <div className="ee-table-scroll">
                  <table className="ee-table">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Buyer</th>
                        <th>Type</th>
                        <th className="ee-r">Amount</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {recentTxns.map((t) => (
                        <tr key={t.transaction_id}>
                          <td>{t.date ?? t.created_at}</td>
                          <td>{t.name_first}</td>
                          <td className="ee-cap">{t.ticket_type.toLowerCase()}</td>
                          <td className="ee-r ee-strong">{formatToZAR(t.amount_gross)}</td>
                          <td>
                            <span className={`ee-pill ee-pill-${t.payment_status.toLowerCase()}`}>
                              {t.payment_status.toLowerCase()}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </section>
          </div>

          {/* ---------- Side column ---------- */}
          <aside className="ee-side">
            <section className="ee-card ee-campaign">
              <div className="ee-campaign-info">
                <span
                  className={`ee-dot ${notPublished ? 'is-idle' : paused ? 'is-paused' : 'is-live'}`}
                />
                <div>
                  <strong>
                    {notPublished
                      ? 'Not published yet'
                      : paused
                        ? 'Campaign paused'
                        : 'Campaign live'}
                  </strong>
                  <p>
                    {notPublished
                      ? 'Buyers cannot see this event.'
                      : paused
                        ? 'The event is hidden from the public.'
                        : 'The event is visible to the public.'}
                  </p>
                </div>
              </div>
              <button
                type="button"
                className={`ee-btn ${paused ? 'ee-btn-primary' : 'ee-btn-ghost'}`}
                onClick={resumeAModal}
              >
                {paused ? <IoPlayOutline size={16} /> : <IoPauseOutline size={16} />} {statusString}
              </button>
            </section>

            {!cancelledOrPostponed && (
              <section className="ee-card">
                <div className="ee-card-head">
                  <h2>Get ready to sell</h2>
                  <span className="ee-count">
                    {doneCount} of {steps.length}
                  </span>
                </div>
                <div
                  className="ee-progress"
                  role="progressbar"
                  aria-valuemin={0}
                  aria-valuemax={steps.length}
                  aria-valuenow={doneCount}
                >
                  <span style={{ width: `${(doneCount / steps.length) * 100}%` }} />
                </div>

                <ol className="ee-steps">
                  {steps.map((s, i) => (
                    <li key={s.key}>
                      <button
                        type="button"
                        className={`ee-row ee-step ${s.done ? 'is-done' : ''} ${isLive ? '' : 'is-locked'}`}
                        onClick={s.onClick}
                      >
                        <span className="ee-step-mark">{s.done ? <IoCheckmark /> : i + 1}</span>
                        <span className="ee-row-text">
                          <span className="ee-row-title">{s.title}</span>
                          <span className="ee-row-hint">{s.hint}</span>
                        </span>
                        <IoChevronForward className="ee-row-chev" />
                      </button>
                    </li>
                  ))}
                </ol>

                {ticketCount > 0 && (
                  <button
                    type="button"
                    className={`ee-row ee-redownload ${canDownload ? '' : 'is-locked'}`}
                    onClick={canDownload ? reprint : functionControl}
                  >
                    <Row
                      icon={<IoCloudDownloadOutline />}
                      title="Re-download tickets"
                      right={<span className="ee-badge">{ticketCount}</span>}
                    />
                  </button>
                )}
              </section>
            )}

            <section className="ee-card ee-list">
              <Link
                className={`ee-row ${deleted == 0 ? '' : 'is-locked'}`}
                to={{ pathname: 'analytics', state: { ...routeState, back: 'editevent' } }}
              >
                <Row icon={<IoAnalyticsOutline />} title="Analytics" hint="Sales and attendance" />
              </Link>
              <Link
                className="ee-row"
                to={{
                  pathname: '/payout',
                  state: { eventid, eventname, is_sponsorship },
                }}
              >
                <Row icon={<IoWalletOutline />} title="Payout" hint="Earnings and withdrawals" />
              </Link>
              <Link
                className="ee-row"
                to={{
                  pathname: '/view-refund-request',
                  state: { eventid, eventname, is_sponsorship },
                }}
              >
                <Row
                  icon={<IoReceiptOutline />}
                  title="Refunds"
                  hint="Requests from ticket holders"
                />
              </Link>
            </section>

            <section className="ee-card ee-list ee-danger">
              <h2 className="ee-list-title">More actions</h2>
              {!cancelledOrPostponed && (
                <>
                  <button
                    type="button"
                    className={`ee-row ${isLive ? '' : 'is-locked'}`}
                    onClick={isLive ? postpone : functionControl}
                  >
                    <Row
                      icon={<IoCalendarOutline />}
                      title="Postpone event"
                      hint="Notify ticket holders of a new date"
                    />
                  </button>
                  <button
                    type="button"
                    className={`ee-row ${isLive ? '' : 'is-locked'}`}
                    onClick={isLive ? cancelModal : functionControl}
                  >
                    <Row
                      icon={<IoCloseCircleOutline />}
                      title="Cancel event"
                      hint="Final. Ticket holders are notified"
                    />
                  </button>
                </>
              )}
              <button
                type="button"
                className={`ee-row ${isLive ? '' : 'is-locked'}`}
                onClick={isLive ? delModal : functionControl}
              >
                <Row
                  danger
                  icon={<IoTrashOutline />}
                  title="Delete event"
                  hint="Permanent. Cannot be undone"
                />
              </button>
            </section>
          </aside>
        </div>
      </div>

      {/* ================= Modals ================= */}

      {/* Pause / resume campaign */}
      <Dialog open={resumeModal} onClose={closeModal}>
        <div className="ee-mb">
          <h3>{paused ? 'Resume campaign' : 'Pause campaign'}</h3>
          <p className="ee-mb-text">
            {paused
              ? 'Make your event live again. You can pause or update it any time.'
              : 'The event will be hidden from the public. You can resume any time.'}
          </p>
          <div className="ee-actions">
            <button type="button" className="ee-btn ee-btn-ghost" onClick={cancel}>
              Cancel
            </button>
            <button
              type="button"
              className={`ee-btn ${paused ? 'ee-btn-primary' : 'ee-btn-dark'}`}
              onClick={resumeCampaign}
            >
              {busy ? <ClipLoader color="#fff" size={16} /> : statusString}
            </button>
          </div>
        </div>
      </Dialog>

      {/* Postpone / cancel */}
      <Dialog open={postponeEvent} onClose={closeModal}>
        <div className="ee-mb">
          <h3>
            {actionBtn === 'Confirm Cancellation' ? 'Cancel this event' : 'Postpone this event'}
          </h3>

          <label className="ee-field">
            <span>Reason</span>
            <select value={reason} onChange={(e) => setReason(e.target.value)} className="ee-input">
              <option value="">Select a reason</option>
              {REASONS.map((obj) => (
                <option key={obj.value} value={obj.value}>
                  {obj.label}
                </option>
              ))}
            </select>
          </label>

          <label className="ee-field">
            <span>Message to ticket holders</span>
            <textarea
              className="ee-input"
              rows={4}
              value={message}
              placeholder="Write a message (also propose a new date)"
              onChange={handleMessage}
            />
          </label>

          <p className="ee-note">
            {numberOfcustomers == 1
              ? '1 ticket holder will be notified.'
              : `${numberOfcustomers} ticket holders will be notified.`}
          </p>

          {actionBtn === 'Confirm Cancellation' && (
            <p className="ee-note ee-note-danger">
              This action is final. Once cancelled, the event cannot be reinstated.
            </p>
          )}

          <div className="ee-actions">
            <button
              type="button"
              className="ee-btn ee-btn-ghost"
              onClick={closeModal}
              disabled={busy}
            >
              Close
            </button>
            <button
              type="button"
              className={`ee-btn ${actionBtn === 'Confirm Cancellation' ? 'ee-btn-danger' : 'ee-btn-primary'}`}
              onClick={postponeTheEvent}
              disabled={busy}
            >
              {busy ? <ClipLoader color="#fff" size={16} /> : actionBtn}
            </button>
          </div>
        </div>
      </Dialog>

      {/* Poster upload */}
      <Dialog open={addPoster} onClose={closeModal}>
        <div className="ee-mb">
          <h3>Upload poster</h3>
          <label
            className={`ee-drop ${image ? 'has-image' : ''}`}
            style={image ? { backgroundImage: `url(${image})` } : undefined}
          >
            {!image && (
              <span className="ee-drop-inner">
                <IoAdd size={30} />
                Click to select a poster
                <small>JPG, PNG, WEBP or GIF</small>
              </span>
            )}
            <input
              name="file"
              type="file"
              onChange={selectImage}
              id="image"
              accept=".jpg,.jpeg,.png,.webp,.gif"
              className="ee-file"
            />
          </label>
          <div className="ee-actions">
            <button type="button" className="ee-btn ee-btn-ghost" onClick={closeModal}>
              Close
            </button>
            <button
              type="button"
              className="ee-btn ee-btn-primary"
              style={{ display: hideUploadBtn }}
              onClick={uploadPoster}
              disabled={busy}
            >
              {busy ? (
                <ClipLoader color="#fff" size={16} />
              ) : (poster || '').trim() === '' ? (
                'Add poster'
              ) : (
                'Update poster'
              )}
            </button>
          </div>
        </div>
      </Dialog>

      {/* Blocked-action explainer */}
      <Dialog open={controlModal} onClose={closeModal}>
        <div className="ee-mb">
          <h3>One thing first</h3>
          <p className="ee-mb-text">
            {checktickets == 'no' ? (
              <>
                You first have to{' '}
                <button
                  type="button"
                  className="ee-linkbtn"
                  onClick={() => {
                    setControlModal(false)
                    openModal()
                  }}
                >
                  load tickets
                </button>{' '}
                before you can do anything.
              </>
            ) : checkposter == 'no' ? (
              <>
                Now that tickets are loaded,{' '}
                <button
                  type="button"
                  className="ee-linkbtn"
                  onClick={() => {
                    setControlModal(false)
                    addAPoster()
                  }}
                >
                  upload a poster
                </button>{' '}
                and then create a campaign.
              </>
            ) : (
              delString
            )}
          </p>
          <div className="ee-actions">
            <button type="button" className="ee-btn ee-btn-ghost" onClick={cancel}>
              Close
            </button>
          </div>
        </div>
      </Dialog>

      {/* Delete */}
      <Dialog open={deleteModal} onClose={closeModal}>
        <div className="ee-mb">
          <h3>Delete this event?</h3>
          <p className="ee-mb-text">This action is permanent and cannot be undone.</p>
          <div className="ee-actions">
            <button type="button" className="ee-btn ee-btn-ghost" onClick={cancel}>
              Cancel
            </button>
            <button type="button" className="ee-btn ee-btn-danger" onClick={deleteEvent}>
              {busy ? <ClipLoader color="#fff" size={16} /> : 'Delete event'}
            </button>
          </div>
        </div>
      </Dialog>

      {/* Load tickets */}
      <Dialog open={showModal} onClose={closeModal} size="lg">
        <div className="ee-mb">
          <h3>Load tickets</h3>
          <p className="ee-mb-text">
            Choose a ticket type, then set the price and how many to add.
          </p>

          <div className="ee-tiers" role="tablist">
            {tiers.map((t) => (
              <button
                key={t.name}
                type="button"
                role="tab"
                aria-selected={currentSelect === t.name}
                className={`ee-tier ${currentSelect === t.name ? 'is-active' : ''}`}
                onClick={() => selectTier(t.onSelect)}
              >
                <strong>{t.name}</strong>
                <span>Adults: {t.adults}</span>
                <span>Kids: {t.kids}</span>
              </button>
            ))}
          </div>

          <label className="ee-check">
            <input
              type="checkbox"
              checked={isComp}
              onChange={(e) => toggleComp(e.target.checked)}
              style={{
                width: '16px',
                height: '16px',
                flexShrink: 0,
                cursor: 'pointer',
              }}
            />
            <span>
              <strong>Complimentary / sponsored</strong>
              <small>
                Hidden from the public. Only people with your code can claim these, at the price
                below (R0 allowed). You can still load paid {currentSelect} tickets separately.
              </small>
            </span>
          </label>

          <div className="ee-form-grid">
            <fieldset>
              <legend>Adults</legend>
              <label className="ee-field">
                <span>Ticket price (R)</span>
                <input
                  type="text"
                  inputMode="decimal"
                  placeholder="Price"
                  value={selectedPrice}
                  onChange={handlePrice}
                  className="ee-input"
                  disabled={isComp && !!compLoaded}
                />
              </label>
              <label className="ee-field">
                <span>{isComp ? 'Tickets to allocate' : 'Add or top-up tickets'}</span>
                <input
                  type="text"
                  inputMode="numeric"
                  placeholder="Load tickets"
                  value={selectedTicket}
                  onChange={handleTickets}
                  className="ee-input"
                  disabled={isComp && !!compLoaded}
                />
              </label>
            </fieldset>

            <fieldset>
              <legend>Kids</legend>
              <label className="ee-field">
                <span>Ticket price (R)</span>
                <input
                  type="text"
                  inputMode="decimal"
                  placeholder="Ticket price"
                  value={kidsSelectedPrice}
                  onChange={handle_kids_price}
                  className="ee-input"
                  disabled={isComp && !!compLoaded}
                />
              </label>
              <label className="ee-field">
                <span>{isComp ? 'Tickets to allocate' : 'Add or top-up tickets'}</span>
                <input
                  type="text"
                  inputMode="numeric"
                  placeholder="Load tickets"
                  value={kidsSelectedTicket}
                  onChange={handle_kids_tickets}
                  className="ee-input"
                  disabled={isComp && !!compLoaded}
                />
              </label>
            </fieldset>
          </div>

          {isComp && (
            <div className="ee-comp">
              {topUpOptions.length > 0 && (
                <label className="ee-field">
                  <span>Allocate to</span>
                  <select
                    className="ee-input"
                    value={compTopUp}
                    onChange={(e) => handleTopUp(e.target.value)}
                    disabled={!!compLoaded}
                  >
                    <option value="">New code (generated when you save)</option>
                    {topUpOptions.map((c) => {
                      const left = (Number(c.allocated) || 0) - (Number(c.used) || 0)
                      return (
                        <option key={c.code} value={c.code}>
                          {c.code}
                          {c.label ? ` · ${c.label}` : ''} ({left} left)
                        </option>
                      )
                    })}
                  </select>
                </label>
              )}

              <div className="ee-comp-grid">
                <label className="ee-field">
                  <span>Sponsor / recipient (optional)</span>
                  <input
                    type="text"
                    className="ee-input"
                    placeholder="e.g. Acme Sponsors"
                    value={compLabel}
                    onChange={(e) => setCompLabel(e.target.value)}
                    disabled={!!compLoaded || !!compTopUp}
                  />
                </label>
                <label className="ee-field">
                  <span>Max tickets per order</span>
                  <input
                    type="text"
                    inputMode="numeric"
                    value={compMaxPerOrder}
                    onChange={(e) => {
                      setCompMaxPerOrder(e.target.value)
                      setFormMsg(null)
                    }}
                    className="ee-input"
                    disabled={!!compLoaded}
                  />
                </label>
              </div>

              <p className="ee-comp-hint">{compSummary}</p>

              <div className="ee-code-box">
                {!compCode ? (
                  <span className="ee-code-meta">
                    {compTopUp
                      ? `Tickets will be added to ${compTopUp}.`
                      : 'A unique sponsor code is generated automatically when you save.'}
                  </span>
                ) : (
                  <>
                    <span className="ee-code-value">{compCode}</span>
                    <div className="ee-code-actions">
                      <button
                        type="button"
                        className="ee-btn ee-btn-ghost"
                        onClick={() => copyText('code', compCode)}
                      >
                        {copied === 'code' ? (
                          <IoCheckmark size={16} />
                        ) : (
                          <IoCopyOutline size={16} />
                        )}{' '}
                        {copied === 'code' ? 'Copied' : 'Copy code'}
                      </button>
                      <button
                        type="button"
                        className="ee-btn ee-btn-ghost"
                        onClick={() => copyText('link', purchaseLink)}
                      >
                        {copied === 'link' ? (
                          <IoCheckmark size={16} />
                        ) : (
                          <IoLinkOutline size={16} />
                        )}{' '}
                        {copied === 'link' ? 'Copied' : 'Copy purchase link'}
                      </button>
                      <button type="button" className="ee-btn ee-btn-ghost" onClick={startAnother}>
                        <IoAdd size={16} /> Another code
                      </button>
                    </div>
                    <span className="ee-code-meta">
                      Saved for {compLoaded}. Send the recipient this code and the purchase link.
                      They tap "Sponsored ticket" and enter it.
                    </span>
                  </>
                )}
              </div>
            </div>
          )}

          {formMsg && (
            <div role="alert" style={alertStyle(formMsg.type)}>
              {formMsg.text}
            </div>
          )}
          <div className="ee-actions">
            <button type="button" className="ee-btn ee-btn-ghost" onClick={cancel}>
              {cancelTitle}
            </button>
            <button
              type="button"
              className="ee-btn ee-btn-primary"
              onClick={update}
              disabled={busy || (isComp && !!compLoaded)}
            >
              {busy ? (
                <ClipLoader color="#fff" size={16} />
              ) : (
                `Load ${currentSelect} ${isComp ? 'complimentary ' : ''}tickets`
              )}
            </button>
          </div>
        </div>
      </Dialog>

      {/* All transactions */}
      <Dialog open={txModal} onClose={() => setTxModal(false)} size="xl">
        <div className="ee-mb ee-tx">
          <div className="ee-tx-head">
            <div>
              <h3>Transactions</h3>
              <p className="ee-mb-text ee-tight">
                {filteredTxns.length} {filteredTxns.length === 1 ? 'transaction' : 'transactions'}
                {txFiltersActive ? ` of ${txns.length}` : ''}
                {' · '}
                {formatToZAR(filteredCompleteTotal)} completed
                {eventname ? ` · ${eventname}` : ''}
              </p>
            </div>
          </div>

          <div className="ee-tx-tools">
            <div className="ee-search">
              <IoSearchOutline />
              <input
                type="search"
                className="ee-input"
                placeholder="Search buyer, ID or ticket type"
                value={txSearch}
                onChange={(e) => {
                  setTxSearch(e.target.value)
                  setTxPage(1)
                }}
              />
            </div>
            <label className="ee-tools-field">
              <span>From</span>
              <input
                type="date"
                className="ee-input"
                value={txFrom}
                max={txTo || undefined}
                onChange={(e) => {
                  setTxFrom(e.target.value)
                  setTxPage(1)
                }}
              />
            </label>
            <label className="ee-tools-field">
              <span>To</span>
              <input
                type="date"
                className="ee-input"
                value={txTo}
                min={txFrom || undefined}
                onChange={(e) => {
                  setTxTo(e.target.value)
                  setTxPage(1)
                }}
              />
            </label>
            <label className="ee-tools-field">
              <span>Status</span>
              <select
                className="ee-input"
                value={txFilter}
                onChange={(e) => {
                  setTxFilter(e.target.value)
                  setTxPage(1)
                }}
              >
                <option value="ALL">All</option>
                <option value="COMPLETE">Complete</option>
                <option value="PENDING">Pending</option>
                <option value="CANCELLED">Cancelled</option>
                <option value="ABANDONED">Abandoned</option>
              </select>
            </label>
            {txFiltersActive && (
              <button type="button" className="ee-btn ee-btn-ghost" onClick={clearTxFilters}>
                Clear
              </button>
            )}
          </div>

          <div className="ee-tx-body">
            <table className="ee-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Date</th>
                  <th>Buyer</th>
                  <th>Type</th>
                  <th className="ee-r">Admissions</th>
                  <th className="ee-r">Amount</th>
                  <th>Status</th>
                  <th>Refund status</th>
                  <th className="ee-r">Refunded</th>
                </tr>
              </thead>
              <tbody>
                {pagedTxns.length === 0 ? (
                  <tr>
                    <td colSpan={9} className="ee-empty ee-center">
                      {txFiltersActive
                        ? 'No transactions match these filters.'
                        : 'No transactions yet.'}
                    </td>
                  </tr>
                ) : (
                  pagedTxns.map((t) => (
                    <tr key={t.transaction_id}>
                      <td className="ee-mono">…{t.transaction_id.slice(-6)}</td>
                      <td>{t.date ?? t.created_at}</td>
                      <td>{t.name_first}</td>
                      <td className="ee-cap">{t.ticket_type.toLowerCase()}</td>
                      <td className="ee-r">{t.admissions}</td>
                      <td className="ee-r ee-strong">{formatToZAR(t.amount_gross)}</td>
                      <td>
                        <span className={`ee-pill ee-pill-${t.payment_status.toLowerCase()}`}>
                          {t.payment_status.toLowerCase()}
                        </span>
                      </td>
                      <td>
                        {t.refund_status !== null ? (
                          <span
                            className={`ee-pill ${
                              t.refund_status === 'pending'
                                ? 'ee-pill-pending'
                                : t.refund_status === 'approved'
                                  ? 'ee-pill-complete'
                                  : 'ee-pill-cancelled'
                            }`}
                          >
                            {t.refund_status}
                          </span>
                        ) : (
                          <span className="ee-muted">None</span>
                        )}
                      </td>
                      <td className="ee-r">{formatToZAR(t.amount_refunded)}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          <div className="ee-tx-foot">
            <span className="ee-muted">
              Page {txPage} of {txPages}
            </span>
            <div className="ee-tx-foot-actions">
              <button
                type="button"
                className="ee-btn ee-btn-ghost"
                onClick={() => setTxPage((p) => Math.max(p - 1, 1))}
                disabled={txPage === 1}
              >
                Previous
              </button>
              <button
                type="button"
                className="ee-btn ee-btn-ghost"
                onClick={() => setTxPage((p) => Math.min(p + 1, txPages))}
                disabled={txPage === txPages}
              >
                Next
              </button>
              <button
                type="button"
                className="ee-btn ee-btn-dark"
                onClick={() => setTxModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </Dialog>

      {errorDisplay === 'block' && (
        <div className={`ee-toast ee-toast-${toastType}`} role="status">
          {String(error)}
        </div>
      )}
    </div>
  )
}

export default Editevent
